import openModalAction from 'modules/modal/redux/actions/open'
import { MODAL_ID } from 'modules/modal/redux/constants'

export function openSpendMoreToUnlockExtraFreeSamplesModalCartAction () {
  return (dispatch) => {
    dispatch(openModalAction(MODAL_ID.SPEND_MORE_TO_UNLOCK_EXTRA_FREE_SAMPLES))
  }
}
